export const checkPlaceholders = (htmlContent, json) => {
  const placeholders = new Set([...htmlContent.matchAll(/\{\{(?!\.)(.+?)\}\}/g)].map((match) => match[1]));
  const missingKey = [...placeholders].find((key) => !(key in json));
  return missingKey;
};